const state = {
  roles: [],
  permissions: [],
  groupedPermissions: [],
  rolePermissions: [],
  trashedRoles: [],
  models: [],
}
export default state
